import { FC } from 'react';
import Image from "next/legacy/image";
import { Box } from '@mui/material';
import { socialButtonsStyles } from './social-buttons.styles';
import facebookIcon from '@/public/assets/icons/facebook.svg';
import tiktokIcon from '@/public/assets/icons/tik-tok.svg';
import linkedinIcon from '@/public/assets/icons/linked-in.svg';
import InstagramIcon from '@mui/icons-material/Instagram';
import ExternalLink from '../links/External-link';
import { Showable, useStyles, clsx } from '@sweatpals/react-ui-kit';
import ImageWrapper from '../images/Image-wrapper';
import { SafeNumber } from '../../types/next.types';

export interface SocialButtonsProps {
	color?: string;
	instagramUrl?: string;
	ticktockUrl?: string;
	facebookUrl?: string;
	twitterUrl?: string;
	linkedinUrl?: string;
}

const SocialButtons: FC<SocialButtonsProps> = ({
	color = '#fff',
	instagramUrl,
	ticktockUrl,
	facebookUrl,
	twitterUrl,
	linkedinUrl,
}) => {
	const styles = useStyles(socialButtonsStyles, color);

	return (
		<Box sx={styles.root}>
			<Showable show={instagramUrl}>
				<ExternalLink href={instagramUrl} sx={styles.button}>
					<InstagramIcon sx={styles.icon} />
				</ExternalLink>
			</Showable>

			<Showable show={ticktockUrl}>
				<ExternalLink href={ticktockUrl} sx={styles.button}>
					<ImageWrapper sx={styles.icon}>
						<Image
							src={tiktokIcon}
							alt="tiktok"
							width={styles.icon.width as SafeNumber}
							height={styles.icon.height as SafeNumber}
						/>
					</ImageWrapper>
				</ExternalLink>
			</Showable>

			<Showable show={facebookUrl}>
				<ExternalLink href={facebookUrl} sx={styles.button}>
					<ImageWrapper sx={styles.facebookIcon}>
						<Image
							src={facebookIcon}
							alt="facebook"
							width={styles.facebookIcon.width as SafeNumber}
							height={styles.facebookIcon.height as SafeNumber}
						/>
					</ImageWrapper>
				</ExternalLink>
			</Showable>

			<Showable show={twitterUrl}>
				<ExternalLink href={twitterUrl} sx={styles.button}>
					<ImageWrapper sx={styles.icon}>
						<Image
							src={facebookIcon}
							alt="twitter"
							width={styles.icon.width as SafeNumber}
							height={styles.icon.height as SafeNumber}
						/>
					</ImageWrapper>
				</ExternalLink>
			</Showable>

			<Showable show={linkedinUrl}>
				<ExternalLink href={linkedinUrl} sx={styles.button}>
					<ImageWrapper sx={styles.icon}>
						<Image
							src={linkedinIcon}
							alt="linkedin"
							width={styles.icon.width as SafeNumber}
							height={styles.icon.height as SafeNumber}
						/>
					</ImageWrapper>
				</ExternalLink>
			</Showable>
		</Box>
	);
};

export default SocialButtons;
